import type {Content} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import {CtaSingleImage} from './variations/CtaSingleImage'
import {CtaVariation} from './variations/CtaVariation'
import {FormVariations} from './variations/FormVariations'
import {FullWidthVariation} from './variations/FullWidth'

/**
 * Props for `BannerV2`.
 */
export type BannerV2Props = SliceComponentProps<Content.BannerV2Slice> & {
  context: {
    pageUid: string
  }
}

/**
 * Component for "BannerV2" Slices.
 */
const BannerV2 = ({slice, index, context}: BannerV2Props): JSX.Element => {
  switch (slice.variation) {
    case 'cta':
      return <CtaVariation slice={slice} index={index} context={context} />

    case 'ctaSingleImage':
      return <CtaSingleImage slice={slice} index={index} pageUid={context.pageUid} />

    case 'fullWidth':
      return <FullWidthVariation slice={slice} index={index} pageUid={context.pageUid} />

    // Single image and default variation are handled by the same component
    default:
      return <FormVariations slice={slice} index={index} context={context} />
  }
}

export default BannerV2
